import React from 'react'
import PageHeader from '../shared/pageHeader/PageHeader'
// import LeadsCreateContent from '../../Components/leadsViewCreate/LeadsCreateContent'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import State2Header from './State2Header'
import StateCreate from './StateCreate'

const EditState = () => {
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <State2Header />
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <StateCreate />
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default EditState